import { be4feMy2nApi } from './be4feMy2nApi';

const enhancedMy2nApi = be4feMy2nApi.injectEndpoints({
  endpoints: (build) => ({
    cancelBillingEmailCardUpdateMy2N: build.mutation({
      query: (queryArg) => ({
        body: { email: queryArg.email },
        method: 'POST',
        params: { siteId: queryArg.siteId },
        url: `/companies/${queryArg.companyId}/purchase/billing-email/card-update/cancel`,
      }),
    }),
    commitBillingEmailCardUpdateMy2N: build.mutation({
      query: (queryArg) => ({
        body: { email: queryArg.email },
        method: 'POST',
        params: { siteId: queryArg.siteId },
        url: `/companies/${queryArg.companyId}/purchase/billing-email/card-update/commit`,
      }),
    }),
    prepareBillingEmailCardUpdateMy2N: build.mutation({
      query: (queryArg) => ({
        body: { email: queryArg.email },
        method: 'POST',
        params: { siteId: queryArg.siteId },
        url: `/companies/${queryArg.companyId}/purchase/billing-email/card-update/prepare`,
      }),
    }),
    processPaymentMy2N: build.mutation({
      query: (queryArg) => ({
        method: 'POST',
        params: queryArg.params,
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/payments/${queryArg.paymentId}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useCancelBillingEmailCardUpdateMy2NMutation,
  useCommitBillingEmailCardUpdateMy2NMutation,
  useGetMobileVideoPriceInfoMy2NQuery,
  usePrepareBillingEmailCardUpdateMy2NMutation,
  useProcessPaymentMy2NMutation,
} = enhancedMy2nApi;
